import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyFormFlowProviders = loadable(() => import(/* webpackChunkName: "content/createwedding-form-flow-providers" */ './FormFlowProviders'), 'FormFlowProviders');
